import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { CoverageServerAction } from './coverageServer.action';
import { coverageServerInitialState } from './coverageServer.constant';
import { ICoverageServerStore } from './coverageServer.interface';

export const coverageServerReducer = reducerWithInitialState(coverageServerInitialState)
  .case(CoverageServerAction.loadList.started, (state): ICoverageServerStore => ({
    ...state,
    listNetworkStatus: NetworkStatus.Started,
  }))
  .case(CoverageServerAction.loadList.done, (state, { result }): ICoverageServerStore => ({
    ...state,
    data: Object.fromEntries(result.map((server) => [server.serverId, server])),
    listNetworkStatus: NetworkStatus.Done,
  }))
  .case(CoverageServerAction.loadList.failed, (state): ICoverageServerStore => ({
    ...state,
    listNetworkStatus: NetworkStatus.Failed,
  }))
  .case(CoverageServerAction.remove.done, (state, { params }): ICoverageServerStore => {
    const data = { ...state.data };
    delete data[params.serverId];
    return { ...state, data };
  })
  .case(CoverageServerAction.destroy, () => ({ ...coverageServerInitialState }));
